import { useMutation } from "@tanstack/react-query";
import {
  EditableTextAddParams,
  editableTextAdd,
} from "common/api/sakusas/sakusas_editable_text";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";

type UseSakusasEditableTextAddParams = {
  invalidateKeys?: string[];
};

export const useSakusasEditableTextAdd = (
  hookParams?: UseSakusasEditableTextAddParams
) => {
  const { invalidateQueriesByKeys } = useInvalidateQueryByKeys();
  const { mutate: editableTextAddMutate } = useMutation({
    mutationFn: async (editableTextAddParams: EditableTextAddParams) =>
      await editableTextAdd(editableTextAddParams),
    onSuccess: () => {
      if (hookParams?.invalidateKeys) {
        invalidateQueriesByKeys(hookParams.invalidateKeys);
      }
    },
  });

  return { editableTextAddMutate };
};
